import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import Modal from 'atoms/Modal';

import StyledPauseMatchModal from './../PauseMatchModal/StyledPauseMatchModal';
import Button, { SecondaryButton } from 'styled/components/Button';

import { ModalProps } from 'atoms/Modal/ModalTypes';

import { modalsSlice } from 'features/modals/modalsSlice';
import { timeSliceActions } from '../../../features/time/timeSlice';
import { selectMatch } from '../../../features/match/matchSlice';

const ResetAndReloadModal: React.FC<ModalProps> = (props) => {
  const dispatch = useDispatch();
  const match = useSelector(selectMatch);

  const close = () => {
    dispatch(modalsSlice.actions.setResetAndReloadModal(false));
  };

  return (
    <Modal {...props}>
      <StyledPauseMatchModal>
        <div />
        <div className="text">
          <FormattedMessage id="modals.resetAndReload" />
        </div>
        <div className="actions">
          <Button
            onClick={() => {
              dispatch(timeSliceActions.emptyLocalStorage(match.id));
              window.location.reload();
            }}
          >
            <FormattedMessage id="buttons.emptyLocalCache" />
          </Button>
          <SecondaryButton whiteBackground greenText onClick={close}>
            <FormattedMessage id="buttons.cancel" />
          </SecondaryButton>
        </div>
      </StyledPauseMatchModal>
    </Modal>
  );
};

export default ResetAndReloadModal;
